import React, { useState } from 'react';

const SearchForm = ({ onSearch, loading }) => {
  const [prompt, setPrompt] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (prompt.trim()) {
      onSearch(prompt.trim());
    }
  };

  return (
    <form onSubmit={handleSubmit} className="search-form">
      <div className="input-group">
        <input
          type="text"
          value={prompt}
          onChange={(e) => setPrompt(e.target.value)}
          placeholder="Search for email addresses (e.g., 'schools in Delhi email', 'restaurants Mumbai contact')"
          className="search-input"
          disabled={loading}
        />
        <button 
          type="submit" 
          className="search-button"
          disabled={loading || !prompt.trim()}
        >
          {loading ? 'Finding Emails...' : 'Find Emails'}
        </button>
      </div>
    </form>
  );
};

export default SearchForm;
